import { useCallback } from 'react'

import { useLocation } from 'react-router'

export const REPORT_FILTER_QUERY_KEYS = {
  dateFrom: 'date_range_0',
  dateTo: 'date_range_1',
  primaryCategoryId: 'branch.id',
  primaryCategoryName: 'branch.name',
  secondaryCategoryId: 'department.id',
  secondaryCategoryName: 'department.name',
  search: 'search',
} as const

// Angular parity: navigating between a report, its details and Export
// history keeps the date range, location and department, and clears the
// search. Pagination and sort keys belong to the destination's own table.
const CARRIED_FILTER_QUERY_KEYS = [
  REPORT_FILTER_QUERY_KEYS.dateFrom,
  REPORT_FILTER_QUERY_KEYS.dateTo,
  REPORT_FILTER_QUERY_KEYS.primaryCategoryId,
  REPORT_FILTER_QUERY_KEYS.primaryCategoryName,
  REPORT_FILTER_QUERY_KEYS.secondaryCategoryId,
  REPORT_FILTER_QUERY_KEYS.secondaryCategoryName,
]

export const buildReportFilterCarryOverUrl = (
  pathname: string,
  currentSearch: string,
  extraParams: Record<string, string> = {}
): string => {
  const currentParams = new URLSearchParams(currentSearch)
  const nextParams = new URLSearchParams(extraParams)

  CARRIED_FILTER_QUERY_KEYS.forEach((key) => {
    const value = currentParams.get(key)

    if (value) {
      nextParams.set(key, value)
    }
  })

  const query = nextParams.toString()

  return query ? `${pathname}?${query}` : pathname
}

/**
 * Builds report-internal URLs (drill-down, breadcrumbs, Export history)
 * that carry the current report filters from the query string.
 */
export const useReportFilterCarryOver = () => {
  const { search } = useLocation()

  const withReportFilters = useCallback(
    (pathname: string, extraParams?: Record<string, string>) =>
      buildReportFilterCarryOverUrl(pathname, search, extraParams),
    [search]
  )

  return { withReportFilters }
}
